import * as yup from "yup";

export const toBeProducedItemSchema = yup.object().shape({
  itemName: yup.string(),
  s3mm: yup.number().nullable(),
  s2p9mm: yup.number().nullable(),
  s2p6mm: yup.number().nullable(),
  s2mm: yup.number().nullable(),
  s1p8mm: yup.number().nullable(),
  s1p6mm: yup.number().nullable(),
});

export const toBeProducedSchema = yup.object().shape({
  s60_8m: yup.object().shape(toBeProducedItemSchema.fields),

  s60_4m: yup.object().shape(toBeProducedItemSchema.fields),

  s60_3m: yup.object().shape(toBeProducedItemSchema.fields),

  s60_6m: yup.object().shape(toBeProducedItemSchema.fields),

  s48_6m: yup.object().shape(toBeProducedItemSchema.fields),

  s48_4m: yup.object().shape(toBeProducedItemSchema.fields),

  s42_6p5m: yup.object().shape(toBeProducedItemSchema.fields),

  s42_6m: yup.object().shape(toBeProducedItemSchema.fields),

  s42_5m: yup.object().shape(toBeProducedItemSchema.fields),

  s42_4m: yup.object().shape(toBeProducedItemSchema.fields),

  s33_5m: yup.object().shape(toBeProducedItemSchema.fields),

  s19_6m: yup.object().shape(toBeProducedItemSchema.fields),

  s76_6p5m: yup.object().shape(toBeProducedItemSchema.fields),

  s76_4p5m: yup.object().shape(toBeProducedItemSchema.fields),

  s60_5p5m: yup.object().shape(toBeProducedItemSchema.fields),

  s42_6m1: yup.object().shape(toBeProducedItemSchema.fields),

  s42_6m2: yup.object().shape(toBeProducedItemSchema.fields),

  s42_5p2m: yup.object().shape(toBeProducedItemSchema.fields),

  s42_4p5m: yup.object().shape(toBeProducedItemSchema.fields),

  s33_6m: yup.object().shape(toBeProducedItemSchema.fields),

  s33_4m: yup.object().shape(toBeProducedItemSchema.fields),

  s27_6m: yup.object().shape(toBeProducedItemSchema.fields),

  s48_5m: yup.object().shape(toBeProducedItemSchema.fields),
});
